export const findThreshold = (thresholds: number[], current: number) => {
  if (!thresholds.length) {
    return null;
  }

  const sortedDesc = [...thresholds].sort((a, b) => b - a);
  const max = sortedDesc[0];
  const min = sortedDesc[sortedDesc.length - 1];

  // Если текущее значение >= максимального порога
  if (current >= max) {
    return max;
  }

  // Если текущее значение <= максимального порога
  if (current <= min) {
    return min;
  }

  // Если текущее значение совпадает с порогом
  const exact = thresholds.find((t) => t === current);

  if (exact) {
    return exact;
  }

  // Ищем сегмент, где current стоит между curr и next
  for (let i = 0; i < sortedDesc.length; i++) {
    const curr = sortedDesc[i];
    const next = sortedDesc[i + 1] ?? 0;

    if (current < curr && current > next) {
      return curr;
    }
  }

  return null;
};
